import React, { useState, useEffect } from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { HomefieldIconAlertErrorFilled } from '@dsg-tech/homefield-react-icons';
import { isSkuSelectionUndefinedSelector } from 'store/selectors';
import { useAppSelector } from 'store/store';

type AttributeGroupProps = {
  attribute: string;
  potential: string[];
  enabled: string[];
  selected: string;
  handleClick: (name: string, value: string) => void;
  validate: boolean;
  skuDefaultAttributes: { [key in string]: string }[];
};

const AttributeGroup = (props: AttributeGroupProps) => {
  const { attribute, potential, enabled, selected, handleClick, validate, skuDefaultAttributes } =
    props;

  const [error, setError] = useState(false);

  const isSkuSelectionUndefined = useAppSelector(isSkuSelectionUndefinedSelector);

  useEffect(() => {
    if (skuDefaultAttributes?.length) {
      skuDefaultAttributes.forEach(
        (attr) => attr.name !== 'Color' && handleClick(attr.name, attr.value),
      );
    }
  }, [skuDefaultAttributes]);

  useEffect(() => {
    if (validate && !Array.isArray(selected) && selected.length === 0) {
      setError(true);
    } else if (selected && selected.length > 0) {
      setError(false);
    }
  }, [selected, validate]);

  return (
    <div
      className="attribute qv-size"
      aria-labelledby={`AttributeGroup-${attribute.replace(' ', '-')}`}>
      {!error ? (
        <p
          id={`AttributeGroup-${attribute.replace(' ', '-')}`}
          className={`caption hmf-body-bold-m label-base hmf-m-0 hmf-mb-xs hmf-text-transform-capitalize ${
            error && 'attribute-error'
          }`}
          data-testid={`quickViewModal_${attribute
            .replace(/[^\w]/gi, '_')
            .replace(/(_+)\1+/g, '$1')}`}>{`${attribute}: ${selected}`}</p>
      ) : (
        <p
          className="attribute-error-message hmf-subheader-bold-s"
          data-testid={`quickViewModal_error_message_${attribute
            .replace(/[^\w]/gi, '_')
            .replace(/(_+)\1+/g, '$1')}`}>
          <HomefieldIconAlertErrorFilled width="16px" height="15px" />
          {` Please Select ${attribute}`}
        </p>
      )}
      <div className="hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-mb-m">
        {potential.map((value) => {
          const isSelected = selected === value;
          const isDisabled = enabled.indexOf(value) < 0;
          return (
            <button
              key={value}
              type="button"
              className={`hmf-py-xxs hmf-px-m hmf-position-relative hmf-mr-xxs hmf-mb-xxs hmf-body-m hmf-sharp-radius value ${
                isSelected && 'selected'
              } ${(isDisabled || (isSelected && isSkuSelectionUndefined)) && 'disabled'}`}
              onClick={() => handleClick(attribute, value)}
              onKeyDown={(e) => handleADA(e, 'button', () => handleClick(attribute, value))}
              data-testid={`quickViewModal${value
                .replace(/[^\w]/gi, '_')
                .replace(/(_+)\1+/g, '$1')}`}>
              {value}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AttributeGroup;
